module.exports = __webpack_public_path__ + "img/Vordach_1.56c5cec8.jpg";